module.exports = __webpack_public_path__ + "static/Reword-5a4c39c4366f26d21f2481b3a7436017.png";